import React, { useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';

export default function Signup(): JsxNode {
  const { loginWithRedirect } = useAuth0();
  useEffect(() => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
        returnTo: window.location.origin,
      },
    });
  });
  return <LoadingIndicator />;
}
